import {useState, useEffect, useMemo} from "react";
import useProductFiltersParams from "../../hooks/useProductFiltersParams";
import {PageHead} from "../../../seo/components/Head";
import React from "react";
import useSite from "../../../sites/hooks/useSite";
import {useRefreshHook} from "../../../common/hooks/useRefresh";
import useRouter from "src/core/common/hooks/useRouter";
import styled from "styled-components";
import media, {contentMaxWidth} from "src/core/common/themes/media";
import {trackCategoryView} from "src/core/analytics/ecommerce/events";
import useFiltersCatalog from "src/core/products/hooks/useFiltersCatalog";

function ProductsBrowser({render}) {
  const [catalog] = useFiltersCatalog();

  const [refreshState] = useRefreshHook();
  const router = useRouter();
  const {productId} = router.query;
  const [paramFilters] = useProductFiltersParams();
  const [filters, setFilters] = useState(paramFilters);

  useEffect(() => {
    if (!productId && !paramFilters.equals(filters)) {
      setFilters(paramFilters);
    }
  }, [productId, setFilters, paramFilters, filters]);

  const category = useMemo(() => {
    const categories = catalog?.categories || [];
    return categories.find((c) => c.getSlug() === filters.category);
    // eslint-disable-next-line
  }, [catalog, filters.category])

  const site = useSite();

  const categoryTitleTemplate = site.getOptions().getCategoryTitleTemplate();

  useEffect(() => {
    category && trackCategoryView(category);
  }, [category]);

  return (
    <React.Fragment>
      {category ? (
        <PageHead
          title={category.getName()}
          description={category.getDescription()}
          titleTemplate={categoryTitleTemplate}
        />
      ) : (
        <PageHead />
      )}
      <Container key={refreshState}>
        {render({
          category,
          filters,
        })}
      </Container>
    </React.Fragment>
  );
}

const Container = styled.div`
  padding-top: 20px;
  > section > header,
  > section > p {
    padding: 0 ${({theme}) => theme.v2.spacing(8)};
    ${media.down("md")} {
      padding: 0 ${({theme}) => theme.v2.spacing(4)};
    }
  }

  width: 100%;
  max-width: ${contentMaxWidth};
  box-sizing: border-box;
`;

export default ProductsBrowser;
